<h2 mat-dialog-title>Sprawdź ceny biletów</h2>

<mat-dialog-content class="overflow-hidden">
	@if (isLoading()) {
		<div class="d-flex flex-column gap-3 py-3">
			<div class="text-center fw-semibold">Wyszukiwanie cen biletów...</div>
			<mat-progress-bar mode="determinate" [value]="progressPercent()"></mat-progress-bar>
			<div class="text-center fw-semibold text-secondary">{{ progressPercent() }}%</div>
		</div>
	} @else if (errorMessage()) {
		<p class="text-danger mb-0">{{ errorMessage() }}</p>
	} @else {
		<div class="d-flex flex-column gap-3 overflow-auto check-ticket-prices-list">
			@if (flightCards().length === 0) {
				<p class="text-secondary mb-0">Brak wyników wyszukiwania.</p>
			} @else {
				@for (card of flightCards(); track $index) {
					<mat-card appearance="outlined">
						<mat-card-content>
							<div class="d-flex justify-content-between align-items-start gap-3 mb-3">
								<div>
									<div class="fw-semibold fs-5">
										<span class="text-secondary">Nr. lotu (wylot):</span>
										<span class="fw-bold">&nbsp;{{ card.flight.flightNumber }}</span>
									</div>
									@if (card.flight.returnFlightNumber) {
										<div class="fw-semibold small mt-1">
											<span class="text-secondary">Nr. lotu (powrót):</span>
											<span class="fw-bold">&nbsp;{{ card.flight.returnFlightNumber }}</span>
										</div>
									}
									<div class="d-flex align-items-center gap-2 mt-1 fs-6">
										<span class="fw-bold text-primary">{{ card.flight.fromCode }}</span>
										<i class="fa-solid fa-plane text-primary"></i>
										<span class="fw-bold text-primary">{{ card.flight.toCode }}</span>
									</div>
								</div>
								<div class="text-end flex-shrink-0">
									<div class="text-secondary small">Cena biletu</div>
									<div class="fw-bold fs-5">{{ +card.flight.price | number: '1.2-2' }} zł</div>
								</div>
							</div>

							<div class="d-flex flex-wrap gap-4 mb-3">
								<div>
									<div class="small text-secondary">Wylot</div>
									<div class="fw-semibold">
										{{ card.flight.departureDate | date: 'dd.MM.yyyy' }},
										{{ card.flight.departureTime }} – {{ card.flight.arrivalTime }}
									</div>
								</div>
								<div>
									<div class="small text-secondary">Powrót</div>
									<div class="fw-semibold">
										{{ card.flight.returnDate | date: 'dd.MM.yyyy' }},
										{{ card.flight.returnDepartureTime }} – {{ card.flight.returnArrivalTime }}
									</div>
								</div>
							</div>

							@if (card.purchasedTickets.length) {
								<div class="rounded bg-light px-3 py-2 mb-3">
									<div class="small text-secondary mb-1">Cena biletów na rezerwacji</div>
									@for (
										ticket of card.purchasedTickets;
										track ticket.city + ticket.price + ticket.participantCount
									) {
										<div class="d-flex justify-content-between align-items-baseline gap-3">
											<span>
												{{ ticket.participantLabel }}
												· {{ ticket.city }}
											</span>
											<span class="fw-semibold flex-shrink-0"
												>{{ ticket.price | price | number: '1.2-2' }} zł za osobę</span
											>
										</div>
									}
								</div>
							}

							@if (card.flight.luggagesPrice?.length) {
								<div class="border-top pt-3">
									<div class="fw-semibold mb-2">Bagaż</div>
									<div class="d-flex flex-column gap-2">
										@for (luggage of card.flight.luggagesPrice; track luggage.name) {
											<div class="d-flex justify-content-between gap-3">
												<span>{{ luggage.name }}</span>
												<span class="fw-semibold flex-shrink-0"
													>{{ luggage.price | number: '1.2-2' }} zł</span
												>
											</div>
										}
									</div>
								</div>
							}
						</mat-card-content>
					</mat-card>
				}
			}

			@if (unavailablePurchasedTickets().length) {
				<div class="d-flex flex-column gap-2">
					<div class="fw-semibold">Połączenia niedostępne</div>
					@for (
						ticket of unavailablePurchasedTickets();
						track ticket.city + ticket.price + ticket.participantCount
					) {
						<div class="border rounded px-3 py-3">
							<div class="d-flex align-items-start gap-2">
								<i class="fa-solid fa-circle-exclamation text-warning mt-1"></i>
								<div>
									<div>
										{{ ticket.participantLabel }} ma wykupiony bilet z miasta {{ ticket.city }} za
										{{ ticket.price | price | number: '1.2-2' }} zł.
									</div>
									<div class="small text-secondary">To połączenie nie jest już dostępne.</div>
								</div>
							</div>
						</div>
					}
				</div>
			}
		</div>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button color="primary" mat-dialog-close>Zamknij</button>
</mat-dialog-actions>
